// extracted by mini-css-extract-plugin
module.exports =  {"button":"e3afc254ff--button--V3g73","button--active":"e3afc254ff--button--active--cziSj","label":"e3afc254ff--label--w54KZ"};